export const joannaRoch = {
    'firstName': 'Joanna',
    'lastName': 'Roch',
    'profession': 'Pedagog, Psychoterapeuta',
    'avatar': 'joanna-roch.webp',
    'slug': 'psychoterapeuta-joanna-roch',
    'locations': ['torun'],
    'services': []
}